module.exports = __webpack_public_path__ + "static/media/Harder To Breathe.21c11aaa.txt";